export function getPhotoThreadMapForDay(day) {
  const photoThreadMap = [];
  const mealPhotos = day?.mealPhotos || {};
  Object.values(mealPhotos).forEach((mealData) => {
    if (mealData?.list) {
      mealData.list.forEach((photo) => {
        const threadId = photo.threadId || photo.thread?._id;
        if (photo._id && threadId) {
          photoThreadMap.push({ photoId: photo._id, threadId });
        }
      });
    }
  });
  return photoThreadMap;
}

export function findMealPhotosDayById(logMealPhotos, dailyStatId) {
  if (!dailyStatId || !logMealPhotos) return null;
  for (const days of Object.values(logMealPhotos)) {
    const day = days.find((d) => String(d._id) === String(dailyStatId));
    if (day) return day;
  }
  return null;
}
